export default __webpack_public_path__ + "static/media/intro_to_programming.3e39beac.jpeg";